import {useDispatch} from "react-redux";
import useCalculationNewHook from "../../../../hooks/useCalculationNewHook";
import CalculationStatus from "../../../../types/CalculationStatus";
import type ConstructionCalculationsNewPanelCalculationItemProps from "./ConstructionCalculationsNewPanelCalculationItemProps";
import useConstructionCalculationsNewPanelCalculationItem from "./useConstructionCalculationsNewPanelCalculationItem";
import {useLocation, useNavigate} from "react-router";
import {updateData} from "../../constructionCalculationsNewSlice";
import styles from "./constructionCalculationsNewPanelCalculationItem.module.scss";
import { Icon } from "@fluentui/react";
import { formatDate } from "./constructionCalculationsNewPanelCalculationItemHelpers";

const ConstructionCalculationsNewPanelCalculationItem: React.FunctionComponent<ConstructionCalculationsNewPanelCalculationItemProps> = ({
    calculation
}) => {
  const {status, calculationId, createdBy, selected, mastResults, endedOn} = calculation;
  const {className, iconName} = useConstructionCalculationsNewPanelCalculationItem(status as CalculationStatus);
  const {getCalculationResults} = useCalculationNewHook();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const handleCalculationClick = (): void => {
    void (async () => {
      const result = await getCalculationResults(calculationId);
      if (result.data) {
        const segments = location.pathname.split("/").filter(Boolean);
        segments[segments.length - 1] = calculationId;
        void navigate(`/${segments.join("/")}`, {replace: true});

        dispatch(
          updateData({
            id: calculationId,
            results: result.data,
          }),
        );
      }
    })();
  };

  return (
    <div
      key={calculationId}
      className={
        selected
          ? `${styles.calculationItem} ${styles.selected}`
          : `${styles.calculationItem}`
      }
      onClick={handleCalculationClick}>
      <div className={styles.calculationHeader}>
        <div className={styles.calculationLeft}>
          <div className={styles.calculationDetails}>
            <div
              className={styles.calculationUser}
              title={`Started by ${createdBy.name}`}>
              <Icon iconName="Contact" />
              <span>{createdBy.name}</span>
              {calculation.isUsedToUpdateConstruction && (
                <Icon
                  iconName="CheckboxCompositeReversed"
                  className={styles.sourceCalculation}
                />
              )}
            </div>

            <div
              title={`Created at ${formatDate(new Date(endedOn), "DD/MM/YYYY HH:mm")}`}
              className={styles.calculationDate}>
              <Icon iconName="DateTime" />
              <span>
                {endedOn
                  ? formatDate(new Date(endedOn), "DD/MM/YYYY HH:MM")
                  : "-"}
              </span>
            </div>

            <div
              title="Used mast profiles"
              className={styles.calculationMastProfiles}>
              <Icon iconName="EntitlementRedemption" />
              {mastResults === undefined ||
                (mastResults === null && <span>-</span>)}
              {mastResults?.map((mast, index) => (
                <div key={index}>
                  <span>{`${mast.profile}`}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.calculationStatus} ${className}`}>
        <Icon iconName={iconName} />
        <span>
          {status === CalculationStatus.Pending ||
          status === CalculationStatus.Created
            ? "In progress"
            : status}
        </span>
      </div>
      {status === CalculationStatus.Pending ||
        (status === CalculationStatus.Created && (
          <div className={styles.progressIndicator}>
            <div className={styles.progressIndicatorItem}>
              <div className={styles.progressIndicatorTrack} />
              <div className={styles.progressIndicatorBar} />
            </div>
          </div>
        ))}
    </div>
  );
};

export default ConstructionCalculationsNewPanelCalculationItem;
